import { Icon, SvgCCOff, SvgCCOn } from '@loomhq/lens';
import React from 'react';

import ControlBarButton from '../control-bar-button';

export default function CcButton({ onClick, ccOn = false }) {
  const hoverTagText = ccOn
    ? 'Turn off closed captions'
    : 'Turn on closed captions';

  return (
    <ControlBarButton
      className="video-player-cc-button"
      hoverTagText={hoverTagText}
      onClick={onClick}
    >
      <Icon
        className="control-bar-button-icon"
        color="white"
        icon={ccOn ? <SvgCCOn /> : <SvgCCOff />}
      />
    </ControlBarButton>
  );
}
